module.exports = "/_next/static/images/PrivacyPortal-77d75612a18769351b47117be101957f.webp";